import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class MyEventServices {
    public toastEvent = new EventEmitter<any>();
    public loadingEvent = new EventEmitter<boolean>();

    showToast(severity: string, title: string, body: string, isSticky = false) {
        let message = { severity, title, body, isSticky };
        this.toastEvent.emit(message);
    }

    toggleLoading(isShowLoading: boolean) {
        this.loadingEvent.emit(isShowLoading);
    }
}